<template>
  <div class="Confirmation">
    <div class="Confirmation__background" role="presentation">
      <div class="Confirmation__edges" role="presentation" />
    </div>
    <div class="Confirmation__main">
      <b-container class="Confirmation__page">
        <div class="Confirmation__content">
          <p>Thank you! <br />Hang tight. We’ll review your application and let you know if we’re a good fit. Currently a waitlist period of 7 days.</p>
          <h1 class="h1">Stay in the know.</h1>
          <b-button aria-label="drivingline.com (opens in a new window)" href="https://www.drivingline.com" target="_blank" variant="primary" class="mb-3 btn-double-outline btn-double-outline--normal">drivingline.com</b-button>
          <SocialGroup />
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import SocialGroup from '@/components/SocialGroup.vue';

export default {
  name: 'Confirmation',
  components: {
    SocialGroup,
  },
  created() {
    // Add a class to the HTML element
    document.documentElement.classList.add('confirmation-page');

    window.removeEventListener('beforeunload', window.NittoPitcrew.beforeUnloadListener, { capture: true });
    window.removeEventListener('unload', window.NittoPitcrew.onUnloadListener);
    window.removeEventListener('pagehide', window.NittoPitcrew.onUnloadListener);
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/_breakpoints.scss';

.Confirmation {
  height: 100%;
  &__main,
  &__page,
  &__content {
    height: 100%;
  }
  &__background {
    background: url('../assets/images/confirm.jpg') top center no-repeat;
    background-size: cover;
    position: absolute;
    top: 0;
    left: 50%;
    width: 100%;
    max-width: 1920px;
    height: 100%;
    z-index: 1;
    min-height: 900px;
    transform: translateX(-50%);
    overflow: hidden;
    @include media-breakpoint-up(lg) {
      &:before {
        content: '';
        background: rgba(0, 0, 0, 0.45);
        height: 100%;
        width: 100%;
        display: block;
      }
    }
    @include media-breakpoint-down(md) {
      // background: url('../assets/images/Confirm@2x.png') top center no-repeat;
      background-image: url('../assets/images/Confirm@2x.png');
      background-position: top center;
      background-repeat: no-repeat;
      min-height: auto;
      position: fixed;
    }
    @include media-breakpoint-down(sm) {
      background-image: url('../assets/images/Confirm.png');
    }
  }

  &__edges {
    position: absolute;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    transition: transform 240ms ease-in-out;
    width: 1920px;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;

    @include media-breakpoint-down(md) {
      display: none;
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 100px;
      height: 100%;
    }

    &::before {
      left: 0;
      background: linear-gradient(to right,
        black 0%,
        black 27%,
        rgba(0, 0, 0, 0.5) 70%,
        transparent 100%);
    }

    &::after {
      right: 0;
      background: linear-gradient(to right,
        transparent 0%,
        rgba(0, 0, 0, 0.5) 30%,
        black 63%,
        black 100%);
    }
  }

  &__content {
    max-width: 343px;
    text-align: center;
    display: flex;
    flex-direction: column;

    h1 {
      @extend %roboto-font-condensed-bold;
      text-transform: uppercase;
    }

    .btn {
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
  }

  &__main {
    position: relative;
    z-index: 10;

    @include media-breakpoint-down(sm) {
      height: calc(100vh - 57px);
    }
  }

  &__page {
    padding-top: 154px;

    @include media-breakpoint-down(sm) {
      padding-top: 57px;
    }
  }
  .SocialGroup {
    width: 100%;
    @include media-breakpoint-down(sm) {
      margin-top: auto;
    }
  }

}
</style>
